<div class="ontario-row center-row-container" *ngIf="notificationsLength === 1">
  <div class="ontario-column medium-6 ontario-small-12">
    <div class="ontario-alert ontario-alert--error" style="margin-top: 10px; margin-bottom: 0px;">
      <div class="ontario-alert__header">
        <h2 class="ontario-alert__header-title ontario-h4">
          <span *ngIf="currentLanguage === 'en'">{{ notifications[0].titleEN }}</span>          
          <span *ngIf="currentLanguage === 'fr'">{{ notifications[0].titleFR }}</span>          
        </h2>
      </div>
      <div class="ontario-alert__body">
        <p *ngIf="currentLanguage === 'en'">{{ notifications[0].descEN }}</p>
        <p *ngIf="currentLanguage === 'fr'">{{ notifications[0].descFR }}</p>
      </div>
    </div>
  </div>
</div>

<div class="ontario-row center-row-container" *ngIf="notificationsLength > 1">
  <div class="ontario-column medium-6 ontario-small-12">
    <div class="ontario-alert ontario-alert--error" style="margin-top: 10px; margin-bottom: 0px;">
      <div class="ontario-alert__header">
        <h2 class="ontario-alert__header-title ontario-h4">{{ 'bss.login.notificationTile' | translate }}:</h2>
      </div>
      <div class="ontario-alert__body">
        <ul>
          <li *ngFor="let notification of notifications">
            <span *ngIf="currentLanguage === 'en'"><strong>{{ notification.titleEN }}</strong> : {{ notification.descEN }}</span>
            <span *ngIf="currentLanguage === 'fr'"><strong>{{ notification.titleFR }}</strong> : {{ notification.descFR }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="ontario-row center-column-container">
  <div class="bpsss-border-line" style="margin-bottom: 10px"></div>
  <div class="ontario-column ontario-small-12 center-row-container">
    <h2 class="ontario-callout__title ontario-h5">
      {{ 'bss.login.x509.ifYouHavePki' | translate }}
    </h2>
  </div>
  <div class="ontario-column ontario-small-12 center-row-container">
    <button tabindex="101" (click)="onCertificateLogin()" 
      class="ontario-button ontario-button--primary" style="margin-top: 0px; margin-bottom: 10px; max-width: 36ex;"
      id="certificate-button" title="{{ 'bss.login.x509.certificate.title' | translate }}">
        {{ 'bss.login.x509.certificate' | translate }}
    </button>
  </div>
  <div class="bpsss-border-line"><span>{{ 'bss.login.or' | translate }}</span></div>

</div>

<div class="ontario-row ontario-small-12 medium-6 center-row-container-end-2">
  <div class="ontario-column ontario-small-12">
    <div tabindex="102" *ngIf="notMatch" class="ontario-alert ontario-alert--error" aria-live="polite" aria-atomic="true" id="pageLevelMessageId"  #pageMsg>
      <div class="ontario-alert__header">
        <div class="ontario-alert__header-icon">
          <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-alert-error"></use>
          </svg>
        </div>
        <h2 class="ontario-alert__header-title ontario-h4">{{ 'bss.login.err.error' | translate }}</h2>
      </div>
      <div class="ontario-alert__body">
        <p [innerHTML]="errorMsgKey | translate"></p>
      </div>
    </div>
  </div>
</div>

<div class="ontario-row center-row-container">
  <div class="ontario-column ontario-small-12 center-row-container">
    <h2 class="ontario-callout__title ontario-h4">
      {{ 'bss.login.newUser' | translate }}
    </h2>
    <span class="ontario-callout__title ontario-label__flag">
      <a tabindex="103" (click)="onRegister()" (keyup.enter)="onRegister()" title="{{ 'bss.login.register.title' | translate }}">
        {{'bss.login.register' | translate }}
      </a>
    </span>
  </div>
</div>

<div class="ontario-row center-column-container">
  <div class="ontario-column ontario-small-12 ontario-medium-6 center-column-container">

    <h2 id="pageTitle">{{ 'bss.login.title' | translate }}</h2>

    <form ngNoForm [formGroup]="loginForm" [action]='oamSubmitUri' method='POST' (ngSubmit)="onSubmit()" #oamLoginForm>
      <div class="ontario-form-group center-column-container">
        <label class="ontario-label" for="username">
          {{ 'bss.login.emailAddress' | translate }} <span class="ontario-label__flag">({{
            'bss.login.emailAddress.register' | translate }})</span>
        </label>
        <input tabindex="104" formControlName="username" type="text" id="username" name="username"
          title="{{ 'bss.login.emailAddress.title' | translate }}" class="ontario-input ontario-input--20-char-width"
          >
        <div id="usernameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
          *ngIf="(submitted || loginForm.get('username').touched || loginForm.get('username').dirty) && (loginForm.get('username').errors?.['required'])">
          {{ 'bss.login.err.email.required' | translate }}
        </div>
        <div id="usernameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
          *ngIf="(submitted || loginForm.get('username').touched || loginForm.get('username').dirty) && (loginForm.get('username').errors?.['restricted'])">
          {{ 'bss.login.err.email.restricted' | translate }}
        </div>

        <label class="ontario-label" for="password">
          {{ 'bss.login.password' | translate }}
        </label>

        <div class="toggle-container ontario-input--20-char-width">
          <input tabindex="105" formControlName="password" id="password" name="password"
            type="{{ showPassword === false ? 'password' : 'text' }}"
            title="{{ 'bss.login.password.title' | translate }}" class="ontario-input ontario-input--20-char-width"
            >

          <a tabindex="106" id="passwordToggler" *ngIf="loginForm.get('password').value" (click)="toggleShowPassword()"
            title="{{ showPassword === false ? ('bss.login.showPassword.title' | translate) : ('bss.login.hidePassword.title' | translate) }}">
            {{ showPassword === false ? ('bss.login.showPassword' | translate) : ('bss.login.hidePassword' | translate)
            }}
          </a>
        </div>

        <div id="passwordError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error"
          *ngIf="(submitted || loginForm.get('password').touched || loginForm.get('password').dirty) && (loginForm.get('password').errors?.['required'])">
          {{ 'bss.login.err.password.required' | translate }}
        </div>
      </div> <!--End of ontario-form-group-->

      <div class="center-row-container-space">
        <button tabindex="107" (click)="onSubmit()" class="ontario-button ontario-button--primary"
          title="{{ 'bss.login.button.title' | translate }}" aria-describedby="pageLevelMessageId">
          {{ 'bss.login.title' | translate }}
        </button>
        <span class="ontario-label__flag"><a tabindex="108" (click)="onForgotPassword()" (keyup.enter)="onForgotPassword()" 
            title="{{ 'bss.login.forgotPassword.title' | translate }}">{{ 'bss.login.forgotPassword' | translate
            }}</a></span>

        <input formControlName="bmctx" type="hidden" id="bmctx" name="bmctx">
        <input formControlName="request_id" type="hidden" id="request_id" name="request_id">
      </div>
    </form>
  </div>
</div>